import ChatBot from "../models/ChatBotModel";
import Keyword from "../models/KeywordModel";
import request from "../shared/http";
import appConfig from "../shared/js/app-config";

const serviceId = appConfig.getServiceId();
class AutomationService {
    parse(item) {
        return {
            id: item.id,
            serviceId: item.service_id,
            templateName: item.chatbot_name,
            template: item.template_json,
            status: item.status,
            trigger: item.trigger ?? 'Event',
            description: item.description ?? 'Remind customers about abandoned cart',
            action: item.action ?? 'Send Message',
            contacts: item.contacts ?? '12',
            lastRun: item.last_run ?? '1hr ago',
            nextRun: item.next_run ?? 'Tomorrow',
        }
    }

    keywordParse(item) {
        return {
            id: item.id,
            serviceId: item.service_id,
            keyword: item.keyword,
            triggerNo: item.trigger_no,
            replyMaterial: item.reply_material,
            chatbotName: item.chatbot_name,
            chatbotId: item.chatbot_is,
            matchMethod: item.match_method,
            templateId: item.template_id,
        }
    }

    serialize(model) {
        return {
            id: model.getId(),
            service_id: model.getServiceId(),
            temlate_name: model.getTemplateName(),
            template_json: model.getTemplate(),
            status: model.getStatus(),
        }
    }
    
    async getChatBot() {
        const url = `/chatbot/${serviceId}`
        const { data } = await request.get(url);
        console.log('data', data);
        
        const response =  data?.map((model) => new ChatBot(this.parse(model)))
        return response;
    }

    async saveKeyWordAction(action) {
        const url = `/keyword/action/${serviceId}`;
        const { data } = await request.put(url, action);
        return data;
    }

    async getKeyWords() {
        const url = `/keywords/${serviceId}`;
        const { data } = await request.get(url);
        const response = data.map((model) => new Keyword(this.keywordParse(model)));
        return response;
    }

    async createChatBot(chatbot) {
        const url = `/chatbot/${serviceId}`;
        const { data } = await request.put(url, chatbot);
        return data;

    }

    async deleteChatbot(id) {
        const url = `/chatbot/delete/${id}`;
        return request.delete(url);
    }
}
export default new AutomationService();